import React, { forwardRef } from "react";
import FormContext from "../../context/FormContext";

const WithFormContextComponent = (Component: any) => {
  const Consumer = forwardRef((props: any, ref) => (
    <FormContext.Consumer>
      {context => {
        const getProp = (propName: string) => {
          if (props[propName]) return props[propName];
          return context[propName] && context[propName][props.id];
        };

        const isDisabled =
          props.disabled ||
          context.disabledAll ||
          (context.disabledAllContent && ['submit-sign', 'submit-signed', 'submit-unsigned'].indexOf(props.id) === -1) ||
          (context.disabled && context.disabled[props.id]);

        return (
          <Component
            {...props}
            disabled={isDisabled}
            error={props.openClose ? context['error'] : getProp("error")}
            hidden={getProp("hidden")}
            id={context.id + props.id}
            onAddFiles={props.onAddFiles || context.onAddFiles}
            onBlur={props.onBlur || context.onBlur}
            onCancelFile={props.onCancelFile || context.onCancelFile}
            onClick={props.onClick || context.onClick}
            onChange={props.onChange || context.onChange}
            onFocus={props.onFocus || context.onFocus}
            onRepeatChange={props.onRepeatChange || context.onRepeatChange}
            ref={ref || context.refs[props.id]}
            repeat={getProp("variables")}
            templateComponents={context.templateComponents}
            validate={
              props.validate ||
              (context.inputs && context.inputs[props.id]
                ? context.inputs[props.id].props.validate
                : undefined)
            }
            variables={context.variables}
            value={getProp("value") ?? ""}
          />
        );
      }}
    </FormContext.Consumer>
  ));

  Consumer.displayName = "WithFormContextComponent";
  return Consumer;
};

export default WithFormContextComponent;
